// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"28c88353","319":"28c88353","922":"28c88353","2529":"28c88353","3616":"28c88353","5168":"a7a2a9e1"}[chunkId] + ".chunk.css";
};